<template>
    <div>
        <section id="single-page-header">
            <div class="overlay">
                <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="single-page-header-left">
                        <h2>{{ $t('menu.regulation') }}</h2>
                    </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="single-page-header-right">

                        <ol class="breadcrumb float-right">
                        <li class="breadcrumb-item">
                            <router-link to="/" class="open_review">
                                {{ $t('menu.home') }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">{{ $t('menu.regulation') }}</li>
                        </ol>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <div class="container top" v-html="description"></div>  
    </div>
</template>
<script>
  export default {
    name: 'Regulation',
    data() {
      return {
        description: ''
      }
    },
    mounted(){
        this.$client.get('getRegulation').then(({data}) => {
          this.description = data.description;
        })
    }
  }
</script>
<style scoped>
    ul{
        list-style: inherit;
    }
    .color{
        color: #09619a;
    }
    .top{
        margin-top: 300px;
    }
    p{
        font-size: 16px;
    }
    .spacing{
        margin-left: 15px;
    }
    strong{
        color: #333;
    }
    table tr td,th{
        border: 1px solid #eaeaea;
        text-align: center;
        font-size: 14px;
        padding: 5px;
    }
    table{
        width: 100%;
    }
    .footer-regulation{
        padding: 10px;
        border: 2px solid #c6ccd0;
        color: #0a6cb6;
        font-size: 12px;
        border-radius: 2px;
        background-color: #c5c5c533;
    }
</style>
